import * as React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import { Translate } from 'react-localize-redux';

import { Link } from 'react-router-dom';
import OpenInNewWindowIcon from '@material-ui/icons/OpenInNew';
import { Typography } from '@material-ui/core';

import { linkTypes } from '../../constants';
import apiUrls from '../../apiUrls';
import Image from '../Image';

const styles = theme => ({
    image: {
        width: '100%',
    },
    audio: {
        width: '100%',
    },
    link: {
        display: 'inline',
        borderBottom: `1px solid ${theme.palette.grey[200]}`,
    },
    fileLink: {
    },
    internalLink: {
    },
    externalLink: {

    },
    icon: {
        marginLeft: theme.spacing(1),
    },
    missingContent: {
        background: theme.palette.grey[100],
        padding: theme.spacing(2),
    },
});

class LinkElement extends React.Component {
    state = {
        paddingBottom: null,
    };

    componentDidMount() {
        window.addEventListener('message', this.handlePostMessage);
    }

    componentWillUnmount() {
        window.removeEventListener('message', this.handlePostMessage);
    }

    handlePostMessage = (event) => {
        if (event.origin === apiUrls.baseUrl && event.data?.source === 'yw@videoPlayer') {
            const aspectRatio = event.data.height / event.data.width;
            if (aspectRatio > 0) {
                this.setState({ paddingBottom: `${aspectRatio * 100}%` });
            }
        }
    }

    render() {
        const {
            classes, link, className, getLinkUrl, autoplayVideos,
        } = this.props;

        if (!link || !link.url) {
            return null;
        }

        const autoplay = autoplayVideos ? '&autoplaymuted=true' : '';

        return (
            <div className={className}>
                {getLinkUrl && (link.linkType === linkTypes.task || link.linkType === linkTypes.module || link.linkType === linkTypes.internal) && (
                    <Link to={getLinkUrl(link)}>
                        <Typography variant="subtitle2" component="span" className={classnames(classes.link, classes.internalLink)}>
                            {link.name }
                        </Typography>
                    </Link>
                )}

                {link.linkType === linkTypes.image && (
                    <Image
                        src={`${apiUrls.baseUrl}/${apiUrls.media.file}/${link.url}`}
                        className={classes.image}
                    />
                )}

                {link.linkType === linkTypes.audio && (
                    <audio controls className={classes.audio}>
                        <source src={`${apiUrls.baseUrl}/${apiUrls.media.file}/${link.url}`} type="audio/mp3" />
                    </audio>
                )}

                {link.linkType === linkTypes.file && (
                    <a href={`${apiUrls.baseUrl}/${apiUrls.media.file}/${link.url}`} target="_blank" rel="noopener noreferrer">
                        <Typography variant="subtitle2" component="span" className={classnames(classes.link, classes.fileLink)}>
                            {link.name || (<Translate id="common.openFile" />)}
                        </Typography>
                    </a>
                )}

                {link.linkType === linkTypes.url && (
                    <a href={link.url} target="_blank" rel="noopener noreferrer">
                        <Typography variant="subtitle2" component="span" className={classnames(classes.link, classes.externalLink)}>
                            {link.name || (<Translate id="common.openLinkInNewWindow" />)}
                        </Typography>
                        <OpenInNewWindowIcon className={classes.icon} />
                    </a>
                )}

                {link.linkType === linkTypes.video && (
                    <div className="videoContainer" style={{ paddingBottom: this.state.paddingBottom }}>
                        <iframe
                            id={`video_${link.url}_player`}
                            title="Youwell video"
                            type="text/html"
                            src={`${apiUrls.baseUrl}/${apiUrls.media.video}/${link.url}?referer=${window.location.origin}${autoplay}`}
                            className="videoFrame"
                            allowFullScreen
                        />
                    </div>
                )}

                {link.linkType === linkTypes.vimeo && (
                    <div className="videoContainer">
                        <iframe
                            id="vplayer"
                            title="Vimeo video"
                            type="text/html"
                            className="videoFrame"
                            src={`https://player.vimeo.com/video/${link.url}?title=0&byline=0&portrait=0`}
                            allowFullScreen
                        />
                    </div>
                )}

                {link.linkType === linkTypes.youtube && (
                    <div className="videoContainer">
                        <iframe
                            id="ytplayer"
                            title="YouTube video"
                            type="text/html"
                            className="videoFrame"
                            src={`https://www.youtube.com/embed/${link.url}?controls=1&fs=0&rel=0&showinfo=0`}
                            allowFullScreen
                        />
                    </div>
                )}
            </div>
        );
    }
}

LinkElement.propTypes = {
    classes: PropTypes.object.isRequired,
    link: PropTypes.object,
    className: PropTypes.string,
    getLinkUrl: PropTypes.func,
    autoplayVideos: PropTypes.bool,
};

LinkElement.defaultProps = {
    link: null,
    className: null,
    getLinkUrl: null,
    autoplayVideos: false,
};

export default withStyles(styles)(LinkElement);
